import AnimatedSection from "@/components/common/AnimatedSection";
import PageHero from "@/components/common/PageHero";
import PageTransition from "@/components/layout/PageTransition";

const implantServices = [
  "Single and multiple implant replacement",
  "Implant-supported overdentures",
  "Bone and bite planning protocols",
  "Long-term implant maintenance guidance",
];

export default function ImplantDentistryPage() {
  return (
    <PageTransition testId="implant-dentistry-page">
      <PageHero
        title="Implant Dentistry"
        subtitle="Precision implant workflows for restoring function, confidence, and long-term oral stability."
        image="https://images.unsplash.com/photo-1609840114035-3c981b782dfe?auto=format&fit=crop&w=2000&q=80"
        testId="implant-dentistry-page-hero"
      />

      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-24">
        <AnimatedSection testId="implant-dentistry-content-section">
          <div className="rounded-2xl border border-[#f2e6c9] bg-white p-8">
            <h2
              className="font-[Playfair_Display] text-3xl text-[#1a1a1a]"
              data-testid="implant-dentistry-services-title"
            >
              Implant Care Pathways
            </h2>
            <ul className="mt-5 space-y-2">
              {implantServices.map((item) => (
                <li
                  key={item}
                  className="font-[Manrope] text-sm text-[#555555]"
                  data-testid={`implant-dentistry-service-${item
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  • {item}
                </li>
              ))}
            </ul>
          </div>
        </AnimatedSection>
      </div>
    </PageTransition>
  );
}
